import { useCallback, useMemo, useState } from 'react';
import { useGetLmsDashboardCalendarQuery } from '../../../../api';
import { getTrainingCategory } from '../utils/dashboardUtils';

const EMPTY = [];

const useLmsDashboardCalendar = () => {
    const [viewMonth, setViewMonth] = useState(() => {
        const today = new Date();
        return { year: today.getFullYear(), month: today.getMonth() + 1 };
    });

    const { data = EMPTY, isFetching } = useGetLmsDashboardCalendarQuery(viewMonth);

    // Tasarımdaki gibi çok günlü eğitimler yalnızca başlangıç gününde gösterilir.
    const events = useMemo(
        () =>
            data.map((item, index) => ({
                id: String(item.planningId),
                title: item.trainingName,
                start: item.startDate,
                allDay: true,
                sortIndex: index,
                extendedProps: { item, category: getTrainingCategory(item.trainingType) }
            })),
        [data]
    );

    const onMonthChange = useCallback((date) => {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        setViewMonth((prev) => (prev.year === year && prev.month === month ? prev : { year, month }));
    }, []);

    return { events, viewMonth, onMonthChange, isFetching };
};

export default useLmsDashboardCalendar;
